import { render, staticRenderFns } from "./product_h5.vue?vue&type=template&id=49c28efd&scoped=true"
import script from "./product_h5.vue?vue&type=script&lang=js"
export * from "./product_h5.vue?vue&type=script&lang=js"
import style0 from "./product_h5.vue?vue&type=style&index=0&id=49c28efd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49c28efd",
  null
  
)

export default component.exports